import { render } from "./ApiDoc.vue?vue&type=template&id=9f5f456a&ts=true"
import script from "./ApiDoc.vue?vue&type=script&lang=ts"
export * from "./ApiDoc.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__